import './index.css';



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4coms/common/style/index.js